import { Link, useLocation } from "@remix-run/react";
import { useState, useEffect } from "react";
import styles from "./Nav.module.css";

const links = [
  { label: "Home", href: "/" },
  { label: "Studio", href: "/studio" },
  { label: "About", href: "/about" },
  { label: "Skillarq", href: "/skillarq" },
  { label: "Blog", href: "/blog" },
  { label: "Press", href: "/press" },
  { label: "Brubri", href: "/brubri" },
  { label: "Burn Rate", href: "/burn-rate" },
  { label: "Contact", href: "/contact" },
];

export default function Nav() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const close = () => setOpen(false);

  if (pathname === "/" || pathname.startsWith("/games/game-") || pathname.startsWith("/naomi/chat")) return null;

  return (
    <>
      <nav className={`${styles.nav} ${scrolled ? styles.navScrolled : ""}`}>
        <Link to="/" className={styles.navLogo} onClick={close}>
          PRODIGIUM DYNAMICS
        </Link>
        <div className={styles.navRight}>
          <button
            className={`${styles.menuBtn} ${open ? styles.menuBtnOpen : ""}`}
            onClick={() => setOpen((v) => !v)}
            aria-label="Menu"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>

      <div className={`${styles.menuOverlay} ${open ? styles.menuOverlayOpen : ""}`}>
        <div className={styles.menuInner}>
          <nav className={styles.menuLinks}>
            {links.map(({ label, href }) => (
              <Link
                key={href}
                to={href}
                className={`${styles.menuLink} ${pathname === href ? styles.menuLinkActive : ""}`}
                onClick={close}
              >
                {label}
              </Link>
            ))}
          </nav>
          <div className={styles.menuFooter}>
            <span>PRODIGIUM DYNAMICS</span>
            <span>EST. 2026</span>
          </div>
        </div>
      </div>
    </>
  );
}
